var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"drawer-backdrop",class:_vm.display}),_vm._v(" "),_c('div',{staticClass:"drawer-container",class:_vm.display},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }